import React from 'react'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'

const NoRowsOverlay = ({customButton}) => (
  <Box alignItems='center' justifyContent='center' width='100%'>
    {customButton ?? <Alert severity='info'>Nothing to see here yet!</Alert>}
  </Box>
)

export default NoRowsOverlay
